enum TransactionPurpose {
  AdHoc = 'N',
  Recurring = 'R',
  Installment = 'I'
}

export default TransactionPurpose;
